import { Dropdown as AntDropDown, DropDownProps } from "antd";
import styled from "styled-components";

export const Dropdown: typeof AntDropDown = styled(
  AntDropDown
)<DropDownProps>``;
